import Admonition from "../Admonitions/Admonition"
import React from "react"

export function OneProgramAdmonition() {
	return (
		<Admonition
			type={"is-info"}
			message={
				<span>
					This Org is under <b>Ready to Launch</b>
				</span>
			}
			isFullWidth
		/>
	)
}
